
const EventEmitter = require('eventemitter3');

const init = function () {
    if (this._initiated) return this;
    const d = this;

    const __setFeatureData = el => {
        const data = el.data || {};
        data.selected = false;
        data.active = false;
        data.index = parseInt(el.dataset.feature);
        el.dataset.selected = false;
        el.data = data;
    }

    d.features = [...d._featuresEl.querySelectorAll('[data-feature]')];
    d.features.forEach(el => {
        __setFeatureData(el);
    });

    this._initiated = true;
    return this;
};

const enable = function () {
    if (!this._initiated) return this;
    if (this._enabled) return this;
    _addEventListeners(this, true);
    this._enabled = true;
    return this;
};

const disable = function () {
    if (!this._initiated) return this;
    if (!this._enabled) return this;
    _addEventListeners(this, false);
    this._enabled = false;
    return this;
};

const destroy = function () {
    if (!this._initiated) return this;
    this.disable();
    this.removeAllListeners();

    this._enabled = false;
    this._initiated = false;

    return this;
};

const goto = function (stage) {
    if (!this._initiated) return this;
    if (this._stage === stage) return this;
    this._prevStage = this._stage;
    this._stage = stage;

    return this;
};



const _activateFeature = function (i) {
    const diagram = this;

    const el = diagram.features[i];

    el.data.active = true;
    el.dataset.active = true;

    if (diagram.activeIndex > -1 && i !== diagram.activeIndex) {
        const prev = diagram.features[diagram.activeIndex];
        prev.data.active = false;
        prev.dataset.active = false;
    }
    diagram.activeIndex = i;

    diagram.activeIndexInSelection = el.data.indexInSelection;
}

const _addEventListeners = (diagram, b) => {
    const d = diagram;

    if (b === false) {
        d.features.forEach(p => {
            const f = p.data.selectHandler;
            if (typeof f === 'undefined') return;
            p.removeEventListener('click', f);
        });
        return;
    }

    d.features.forEach(p => {
        const f = () => {
            _selectFeature(d, p.data.index, p);
        };
        p.data.selectHandler = f;
        p.addEventListener('click', f);
    });
};

const _select = (diagram, i) => {
    diagram.emit('select', i);
};

const _selectFeature = (diagram, i, el) => {
    if (diagram._stage === 'config') {
        _selectFeatureInner(diagram, i, el);
        return;
    }
    if (diagram._stage !== 'fix') return;
    _select(diagram, i);
};

const _selectFeatureInner = (diagram, i, el) => {

    el.data.selected = !el.data.selected;
    el.dataset.selected = el.data.selected;
    if (el.data.selected) {
        diagram._numFeaturesSelected++;
    } else {
        diagram._numFeaturesSelected--;
    }

    _select(diagram, i);
};

module.exports = el => {
    const Diagram = new EventEmitter();
    Diagram._featuresEl = el;


    Diagram.init = init.bind(Diagram);
    Diagram.destroy = destroy.bind(Diagram);
    Diagram.enable = enable.bind(Diagram);
    Diagram.disable = disable.bind(Diagram);
    Diagram.goto = goto.bind(Diagram);
    Diagram.activateFeature = _activateFeature.bind(Diagram);

    return Diagram;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/DiagramFeaturesControl.js